import { render, staticRenderFns } from "./ledgerPayContract.vue?vue&type=template&id=1b108544&scoped=true"
import script from "./ledgerPayContract.vue?vue&type=script&lang=js"
export * from "./ledgerPayContract.vue?vue&type=script&lang=js"
import style0 from "./ledgerPayContract.vue?vue&type=style&index=0&id=1b108544&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b108544",
  null
  
)

export default component.exports